// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DefaultScreenBlock_wrapper__jJzta"};